import React from 'react'
import { HorizontalBannerScroller } from '@/molecules/HorizontalBannerScroller'

export const RecommendedBannerCarouselPlaceholder = () => {
  return (
    <HorizontalBannerScroller dots={false} centerMode centerPadding="32px">
      <div className="px-[2px] md:px-4">
        <div className="aspect-h-9 aspect-w-6 relative w-full overflow-hidden rounded-2xl border-2 border-core-gray-800 leading-[0] sm:aspect-h-2 sm:aspect-w-3 lg:aspect-h-1 lg:aspect-w-3">
          <div className="animate-pulse bg-black" />
        </div>
      </div>
      <div className="px-[2px] md:px-4">
        <div className="aspect-h-9 aspect-w-6 relative w-full overflow-hidden rounded-2xl border-2 border-core-gray-800 leading-[0] sm:aspect-h-2 sm:aspect-w-3 lg:aspect-h-1 lg:aspect-w-3">
          <div className="animate-pulse bg-black" />
        </div>
      </div>
      <div className="px-[2px] md:px-4">
        <div className="aspect-h-9 aspect-w-6 relative w-full overflow-hidden rounded-2xl border-2 border-core-gray-800 leading-[0] sm:aspect-h-2 sm:aspect-w-3 lg:aspect-h-1 lg:aspect-w-3">
          <div className="animate-pulse bg-black" />
        </div>
      </div>
    </HorizontalBannerScroller>
  )
}
